import React, { useEffect, useState } from "react";
import DetailblogForm from "./CommentForm";
import { getBlogByid } from "@store/action/smartend/TopicAction";
import { useDispatch, useSelector } from "react-redux";
import { Link, useRouteMatch } from "react-router-dom";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import CommenByTopic from "./CommentByTopic";
import FilterBlog from "./FilterBlog";
import DOMPurify from "dompurify";
import SwiperAutoplay from "./SwiperAutoplay";
import "@styles/sass/5-pages/blog-details.scss";
import { Spinner } from "reactstrap";

const DetailsByBlogId = ({ t }) => {
  const shareUrl = window.location.href;
  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };
  const dispatch = useDispatch();
  const store = useSelector((state) => state.NewsReducer);
  const datas = store?.single;
  console.log("datasdatas", datas);
  const { id, webmasterTitle } = useRouteMatch().params;
  useEffect(() => {
    dispatch(getBlogByid(webmasterTitle, id));
  }, [dispatch, webmasterTitle, id]);

  const full_name =
    datas &&
    datas.Topic.created_by_user &&
    datas.Topic.created_by_user?.first_name +
      " " +
      datas.Topic.created_by_user?.last_name;

  return (
    <section className="blog-det-part">
      <div className="container__video">
        <div className="row">
          <FilterBlog t={t} dispatch={dispatch} setCurrentPage={() => {}} />
          {datas ? (
            <div className="col-lg-9">
              <div className="blog-det-banner">
                <img
                  width="100%"
                  height="500px"
                  src={
                    datas?.Topic.photo_file
                      ? datas?.Topic.photo_file
                      : "https://media.istockphoto.com/id/1440979913/photo/view-of-stacked-newspapers-on-blurred-background.webp?b=1&s=170667a&w=0&k=20&c=6Kn30RmS2WQthvlh9sTX1BKbaXMYtMQw57_h3zJ5RzM="
                  }
                  alt="blog-details"
                />
                <div className="blog-det-content">
                  <div className="blog-det-title">
                    <div className="mail-body">
                      <div className="mail-message">
                        <h2
                          className="text-truncate mb-0"
                          style={{ color: "white" }}
                        >
                          {datas?.Topic.title}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <ul className="blog-det-meta">
                    <li>
                      <i className="far fa-user"></i>

                      <p>
                        {t("By")}{" "}
                        <Link
                          to={`/dataNews/${webmasterTitle}/topics/created_by/${datas?.Topic?.created_by_user?.id}`}
                        >
                          {full_name}
                        </Link>
                      </p>
                    </li>
                    <li>
                      <i className="far fa-calendar-alt"></i>
                      <p> {datas?.Topic.date} </p>
                    </li>
                    <li>
                      <i className="far fa-comments"></i>
                      <p>
                        {datas?.Topic.commentsCount} {t("Comments")}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="blog-det-descrip content-fluid">
                <div
                  className="preview"
                  dangerouslySetInnerHTML={createMarkup(
                    datas?.Topic.details
                  )}
                ></div>
              </div>
              <SwiperAutoplay data={datas} />
              <div className="blog-det-navigate mt-5">
                <div className="navigate-post">
                  {!datas?.Previous || datas?.Previous.length === 0 ? (
                    <h4> {t("no previous post")} </h4>
                  ) : (
                    <div>
                      <img
                        width="100%"
                        height="200px"
                        src={
                          datas?.Previous.photo_file &&
                          datas?.Previous.photo_file
                        }
                      />
                      <div className="mail-body">
                        <div className="mail-message">
                          <h4 className="text-truncate">
                            <p style={{ color: "white" }}>
                              {datas?.Previous.title}
                            </p>
                          </h4>
                        </div>
                      </div>
                      <Link
                        to={`/dataNews/${webmasterTitle}/topics/${datas?.Previous?.id}`}
                        className="prev-arrow"
                      >
                        <i className="fa fa-long-arrow-left"></i>
                        {t("Previous Post")}
                      </Link>
                    </div>
                  )}
                </div>
                <div className="navigate-post">
                  {!datas?.Next || datas?.Next.length === 0 ? (
                    <h4> {t("no next post")} </h4>
                  ) : (
                    <div>
                      <img
                        width="100%"
                        height="200px"
                        src={
                          datas?.Next.photo_file &&
                          datas?.Next?.photo_file
                        }
                      />
                      <div className="mail-body">
                        <div className="mail-message">
                          <h4 className="text-truncate">
                            <p style={{ color: "white" }}>
                              {datas?.Next.title}
                            </p>
                          </h4>
                        </div>
                      </div>
                      <Link
                        to={`/dataNews/${webmasterTitle}/topics/${datas?.Next?.id}`}
                        className="next-arrow"
                      >
                        {t("Next post")}
                        <i className="fa fa-long-arrow-right"></i>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
              {datas && (
                <div style={{ textAlign: "center" }} className=" mt-2 mb-0">
                  <h3>{t("Share on")} </h3>
                  <ul className="blog-icon">
                    <li>
                      <FacebookShareButton url={shareUrl}>
                        <FacebookIcon size={30} round={true} />
                      </FacebookShareButton>
                    </li>

                    <li>
                      <TwitterShareButton url={shareUrl}>
                        <TwitterIcon size={30} round={true} />
                      </TwitterShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton url={shareUrl}>
                        <WhatsappIcon size={30} round={true} />
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <FacebookMessengerShareButton url={shareUrl}>
                        <FacebookMessengerIcon size={30} round={true} />
                      </FacebookMessengerShareButton>
                    </li>
                    <li>
                      <EmailShareButton>
                        <EmailIcon size={30} round={true} />
                      </EmailShareButton>
                    </li>
                  </ul>
                </div>
              )}
              <CommenByTopic t={t} dispatch={dispatch} />
              <DetailblogForm t={t} dispatch={dispatch} />
            </div>
          ) : (
            <div className="col-lg-9">
              <center>
                <Spinner color="primary" />
              </center>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default DetailsByBlogId;
